<template>
  <div>
    <div>
       <section class="time-line-box">
            <div class="swiper-container text-center"> 
                <div class="swiper-wrapper">
                    <div class="swiper-slide" id="swiper-slide-first">
                      <div class="timestamp" >
                          <div id="order_label" ><span class="count-detail" @click="ShowOutlinerKits(11,-1,'processing',)"><span class="count">{{ report.sold}}</span><br>Sold</span></div>
                          <div id="activated_label"><span class="count-detail" @click="ShowOutlinerKits(0,1,'activated')"><span class="count">{{ report.activated }}</span><br>Activated</span></div>
                      </div>
                      <div class="title" id="order" ><span></span></div>
                      <div class="title" id="activated"><span></span></div>
                    </div>
                </div>
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="timestamp" id="submitted_label"><span @click="ShowOutlinerKits(0,2,'awaiting')" class="count-detail"><span class="count">{{ report.lab_awaiting }}</span><br>Submitted</span></div>
                    <div class="title" id="submitted"><span></span></div>
                  </div>
                </div>
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="timestamp" id="received_label"><span @click="ShowOutlinerKits(0,3,'received')" class="count-detail"><span class="count">{{ report.lab_received }}</span><br>Received</span></div>
                    <div class="title" id="received"><span></span></div>
                  </div>
                </div>
                <div class="swiper-wrapper">
                  <div class="swiper-slide" id="swiper-slide-last">
                    <div class="timestamp" id="completed_label"><span @click="ShowOutlinerKits(0,5,'complete')" class="count-detail"><span class="count">{{ report.analysis_completed }}</span><br>Completed</span></div>
                    <div class="title" id="completed"><span></span></div>
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
         </section>
    </div>
  </div>
  </template>
  
  <script>
  import { mapGetters, mapActions } from "vuex";
  import FilterDays from "../timeline/FilterDays.vue"
  export default {
    name: "Amazontimeline",
    components:{FilterDays},
    data() {
      return {
        report: {
          activated: 0,
          analysis_completed: 0,
          lab_received: 0,
          lab_awaiting: 0,
          on_hold: 0,
          shipped: 0,
          total: 0,
          delivered:0,
          sold:0
        },
        salesData:[]
      };
    },
    computed: {
      ...mapGetters(["getFilterSalesdata",'adminReport'])
    },
    watch: {
      getFilterSalesdata(obj) {
        this.report.sold = obj.reduce((sum, item) => sum + item.unit_count, 0);
      },
      adminReport(obj) {
        for (var k in obj) {
          if (this.report.hasOwnProperty(k)) {
            this.report[k] = Number(obj[k]);
          }
        }
      }
    },
    methods: {
      ...mapActions([
          "sendSearchReq",
          "changeDashboardValues"
      ]),
      ShowOutlinerKits(steps,status,value)
      {
        this.changeDashboardValues();
        if(steps == 0) {
          // this.sendSearchReq();
          this.$emit("switchOrder",{ steps: steps,value: value});
        } else {
          this.getWooOrders();
          this.$emit("switchOrder",{ steps: steps,value: value});
        }
      }
    },
    mounted(){
      this.salesData = this.$store.getters.getFilterSalesdata;
      for (var k in this.$store.getters.adminReport) {
          if (this.report.hasOwnProperty(k)) {
            this.report[k] = Number(this.$store.getters.adminReport[k]);
          }
      }
    }
  };
  </script>
  <style scoped lang="scss">
  @import "../../../styles/colors";
  .col-6{
    width: 50%;
  }
  .date{
    height: 20px;
  }
  .time-line-box {
    width: 100%;
  }
  .time-line-box  .title{
    font-family: TTNormsMedium, sans-serif;
  }
  
  .time-line-box .timeline {
    list-style-type: none;
    display: flex;
    padding: 0;
    text-align: center;
  }
  
  .time-line-box .timestamp {
    margin: auto;
    margin-bottom: 9px;
    padding: 0px 4px;
    display: flex;
    align-items: center;
    font-family: TTNormsMedium, sans-serif;
    font-weight: 400;
  }
  .time-line-box .timestamp .count {
    font-weight: 600;
  }
  
  .swiper-container {
    width: 90%; 
    margin: auto;
    display: flex;
    justify-content: center;
  }
  .swiper-wrapper{
    height: 70px;
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    width: 24%;
  }
  .swiper-container::-webkit-scrollbar-track{
     background:#a8a8a8b6;
  }
  .swiper-container::-webkit-scrollbar{
    height: 2px;
  }
  .swiper-container::-webkit-scrollbar-thumb{
     background: #4F4F4F !important;
  }
  .swiper-slide {
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    width: 100%;
    height: 100%;
    position: relative;
  }
  #swiper-slide-first {
    width: 100%;
  }
  #swiper-slide-last {
    width: 100%;
  }
  .text-center{
    text-align: left;
  }
  .swiper-slide .title span:before {
    content: '';
    width: 16px;
    height: 16px;
    border-radius: 16px;
    position: absolute;
    left: 50%;
    top: 35px;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    transition: all 200ms ease-in;
    z-index: 1;
  }
  .swiper-slide #order span:before {
    background-color: $black;
    border: 2px solid $black;
    z-index: 0;
    left: 0% !important;
  }
  .swiper-slide #shipped span:before {
    background-color: $green;
    border: 2px solid $green;
    left: 96% !important;
  }
  .swiper-slide #delivered span:before {
    background-color: $blue;
    border: 2px solid  $blue;
    left: 96% !important;
  }
  .swiper-slide #activated span:before {
    background-color: $lightGray;
    border: 2px solid $lightGray;
    left: 96% !important;
  }
  .swiper-slide #submitted span:before {
    background-color: $yellow;
    border: 2px solid $yellow;
    left: 96% !important;
  }
  .swiper-slide #received span:before {
    background-color: $heather;
    border: 2px solid  $heather;
    left: 96% !important;
  }
  .swiper-slide #completed span:before {
    background-color: $caribbeanBlue;
    border: 2px solid  $caribbeanBlue;
    left: 96% !important;
  }
  .time-line-box #shipped {
    border-top: 6px solid  $green;
  }
  
  .time-line-box #delivered {
    border-top: 6px solid  $blue;
  }
  
  .time-line-box #activated {
    border-top: 6px solid $lightGray;
  }
  
  .time-line-box #submitted {
    border-top: 6px solid  $yellow;
  }
  
  .time-line-box #received {
    border-top: 6px solid  $heather;
  }
  
  .time-line-box #completed {
    border-top: 6px solid  $caribbeanBlue;
  }
  
  #order_label span {
      color: $black;
  }
  #order_label {
      margin-left: -7% !important;
  }
  
  #shipped_label span {
      color: $green;
  }
  #activated_label{
      margin-left: 83% !important;
  }
  .count-detail{
    cursor: pointer;
  }
  
  #delivered_label .count-detail{
      color: $blue;
      margin-left: 83%;
  }
  
  #activated_label .count-detail{
      color: $lightGray;
  }
  
  #submitted_label .count-detail{
      color: $yellow;
      margin-left: 85%;
  }
  
  #received_label .count-detail{
      color: $heather;
      margin-left: 86%;
  }
  
  #completed_label .count-detail{
      color: $caribbeanBlue;
      margin-left: 85%;
  }
  
  </style>